import _regeneratorRuntime from "/nerv.app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/nerv.app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/nerv.app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/nerv.app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import moment from "moment";
import { getSleepDayReport, getSnoreInfos, getVipFlag } from "../../utils/api";
import { checkVersion, goToOpenVipPage, timeFormat, transferSeconds } from "../../utils/utils";
import PieChart from './components/PieChart.vue';
import PointChart from './components/PointChart.vue';
import VideoList from './components/VideoList.vue';
import DecibelChart from "./components/DecibelChart.vue";
import _en from "../../i18n/langs/en";
import { eventTracking, getLocalPathIds } from "../../utils/native";
import { deepClone } from "vant/es/utils/deep-clone";
export default {
  name: "snoreData",
  components: {
    DecibelChart: DecibelChart,
    PieChart: PieChart,
    PointChart: PointChart,
    VideoList: VideoList
  },
  data: function data() {
    return {
      oversea: true,
      isloading: false,
      firstLoad: true,
      noNet: false,
      flag: '',
      imgVip: require("../../assets/imgs/vip.png"),
      snoreDetail: {
        "sleepStartMillis": null,
        "sleepEndMillis": null,
        "snoringDuration": null,
        // 打鼾时长（秒）
        "maxDecibel": null,
        // 鼾声最大分贝
        "minDecibel": null,
        // 鼾声最小分贝
        "avgDecibel": 66,
        // 鼾声平均分贝
        "highDecibelPercent": null,
        //大于70分贝占比
        "midDecibelPercent": null,
        //大于50分贝小于70占比
        "lowDecibelPercent": null,
        //小于50分贝占比
        snoreList: [],
        displayRecords: []
      },
      snoreDetailDemo: {
        "sleepStartMillis": 1700088881838,
        "sleepEndMillis": 1700103281838,
        "snoringDuration": 4800,
        // 打鼾时长（秒）
        "maxDecibel": 76,
        // 鼾声最大分贝
        "minDecibel": 52,
        // 鼾声最小分贝
        "avgDecibel": 68,
        // 鼾声平均分贝
        "highDecibelPercent": 12,
        //大于70分贝占比
        "midDecibelPercent": 66,
        //大于50分贝小于70占比
        "lowDecibelPercent": 22,
        //小于50分贝占比
        "lowFrequencyPercent": 10,
        "midFrequencyPercent": 60,
        "highFrequencyPercent": 30
      },
      frequencyLists: [],
      hasSleepInfos: false,
      decibelLists: [],
      startTime: moment().startOf('day').valueOf(),
      centerTime: moment().hour(12).minute(0).second(0),
      endTime: moment().endOf('day').valueOf(),
      year: '',
      month: '',
      day: ''
    };
  },
  computed: {
    en: function en() {
      return _en;
    }
  },
  watch: {
    '$route': {
      handler: function handler(route) {
        if (!this.firstLoad) {
          this.getDateByRoute(route);
        }
      },
      immediate: true
    }
  },
  beforeCreate: function beforeCreate() {
    document.title = this.$t("message.snore.snoreReport"); // 标题国际化
  },
  created: function created() {
    this.oversea = localStorage.getItem('oversea') == '1';
    this.firstLoad = false;
    this.isloading = true;
    this.queryIsVip();
    this.getDateByRoute(this.$route);
  },
  methods: {
    timeFormat: timeFormat,
    // 通过路由获取选中模式和日期
    getDateByRoute: function getDateByRoute(route) {
      var _ref = route.params || {},
          year = _ref.year,
          month = _ref.month,
          day = _ref.day;

      this.year = year || moment().year();
      this.month = month || moment().month() + 1;
      this.day = day || moment().date(); // await this.getSleepTimeRange(this.year, this.month, this.day)

      this.getSnoreData(this.year, this.month, this.day);
    },
    getSnoreData: function getSnoreData(year, month, day) {
      var _this = this;

      getSnoreInfos({
        year: year,
        month: month,
        day: day
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          var _iterator, _step, _this$decibelLists, item, frequency, decibel, _this$frequencyLists;

          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.firstLoad = false;
                  console.log('获取鼾声信息=>', res);
                  _this.frequencyLists = [];
                  _this.decibelLists = [];
                  _iterator = _createForOfIteratorHelper(res.snoreList);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      item = _step.value;
                      item.totalTime = item.endSnore - item.startSnore; // console.log('秒数', item.totalTime / 1000)

                      frequency = item.points.map(function (point) {
                        return {
                          x: point.time,
                          y: point.frequency
                        };
                      });
                      frequency = frequency.filter(function (item) {
                        return item.y;
                      }) || [];
                      decibel = item.points.map(function (point) {
                        return {
                          time: point.time,
                          decibel: point.decibel
                        };
                      });

                      if (item.url) {
                        /^(https?:\/\/)/i.test();
                      }

                      if (frequency && frequency.length) {
                        (_this$frequencyLists = _this.frequencyLists).push.apply(_this$frequencyLists, _toConsumableArray(frequency));
                      }

                      (_this$decibelLists = _this.decibelLists).push.apply(_this$decibelLists, _toConsumableArray(decibel));
                    } // 鼾声频率分布数组
                    // console.log('this.frequencyLists =>',  deepClone(this.frequencyLists).map((item)=> {
                    //     return {x: moment(item.x).format('YYYY-MM-DD HH:mm:ss'), y: item.y}
                    // }))

                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  _this.snoreDetail = res;
                  _this.frequencyLists = _this.parseFrequencyData(_this.frequencyLists); // console.log('this.frequencyLists =>', this.frequencyLists)

                  _this.startTime = res.sleepStartMillis;
                  _this.endTime = res.sleepEndMillis;
                  _this.centerTime = Number((res.sleepStartMillis + res.sleepEndMillis) / 2);
                  _this.isloading = false;

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (e) {
        _this.isloading = false;
        console.log('接口错误e', e);
        _this.firstLoad = false;
        _this.snoreDetail = {};
      });
    },
    parseFrequencyData: function parseFrequencyData(data) {
      // 调整值取样时间间隔为10分钟
      var samplingInterval = 10 * 60 * 1000; // 初始化调稀疏后的数组

      var sparseData = [];

      if (data.length) {
        // 初始化当前时间和当前频率的最大值
        var currentTime = data[0].x;
        var maxFrequency = 0;
        var maxFrequencyTime = data[0].x;

        for (var i = 0; i < data.length; i++) {
          var item = data[i]; // 计算当前数据点的时间差

          var timeDiff = item.x - currentTime;

          if (timeDiff < samplingInterval) {
            // 如果时间差小于采样间隔，则更新当前最大频率值
            maxFrequency = Math.max(maxFrequency, item.y);
            maxFrequencyTime = item.y >= maxFrequency ? item.x : maxFrequencyTime;

            if (i === data.length - 1) {
              sparseData.push({
                x: maxFrequencyTime,
                y: Math.min(maxFrequency, 780)
              });
            }
          } else {
            // 如果时间差大于采样间隔，则将当前最大频率值加入调稀疏数组，并更新当前时间和最大频率值
            sparseData.push({
              x: maxFrequencyTime,
              y: Math.min(maxFrequency, 780)
            });
            currentTime = Math.floor(item.x / samplingInterval) * samplingInterval;
            maxFrequencyTime = item.x;
            maxFrequency = item.y;

            if (i === data.length - 1) {
              sparseData.push({
                x: maxFrequencyTime,
                y: Math.min(maxFrequency, 780)
              });
            }
          }
        }
      }

      return sparseData;
    },
    // 获取睡眠的起止时间 - 2023-12-22会议上刘兵提出，这个页面的起止时间，不再使用睡眠数据的
    getSleepTimeRange: function getSleepTimeRange(year, month, day) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, data, _data$, startReal, endReal;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getSleepDayReport({
                  year: year,
                  month: month,
                  day: day
                });

              case 2:
                res = _context2.sent;
                console.log('getSleepTimeRange', res);

                if (res.length) {
                  data = res.filter(function (item) {
                    return item.type === 1;
                  });
                  console.log('data', data);

                  if (data.length) {
                    _data$ = data[0], startReal = _data$.startReal, endReal = _data$.endReal; // 接口返回的秒级别时间戳，需要处理成毫秒级别。

                    _this2.startTime = startReal <= 9999999999 ? startReal * 1000 : startReal;
                    _this2.endTime = endReal <= 9999999999 ? endReal * 1000 : endReal;
                    _this2.centerTime = Number((startReal + endReal) * 1000 / 2);
                    _this2.hasSleepInfos = true;
                  }
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 请求是否为会员
    queryIsVip: function queryIsVip() {
      var _this3 = this;

      getVipFlag().then(function (res) {
        _this3.flag = res.vipFlag; // this.flag = 0;

        _this3.date = res.vaildDate;
      });
    },
    // 跳转开通会员页面
    goOpenVipPage: function goOpenVipPage() {
      if (this.$refs.videoLists) {
        this.$refs.videoLists.endAudioPlayBeforeOut();
      }

      goToOpenVipPage();
    },
    transferSeconds: transferSeconds
  }
};